import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { motion, AnimatePresence } from 'framer-motion';
import './Footer.css';

function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > window.innerHeight);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <span className="footer__logo">SR<span className="footer__logo-dot">.</span></span>
            <p className="footer__tagline">Building scalable systems through thoughtful engineering.</p>
          </div>
          <div className="footer__socials">
            {[
              { href: 'https://github.com/soum-sr', icon: 'fa-brands fa-github' },
              { href: 'https://www.linkedin.com/in/soumyajitrout/', icon: 'fa-brands fa-linkedin' },
              { href: 'https://stackoverflow.com/users/11289239/soumyajit', icon: 'fa-brands fa-stack-overflow' },
              { href: 'https://medium.com/@soum1071', icon: 'fa-brands fa-medium' },
              { href: 'mailto:soum1071@gmail.com', icon: 'fa-solid fa-envelope' },
            ].map((s) => (
              <a key={s.icon} href={s.href} target="_blank" rel="noreferrer" className="footer__social-link">
                <i className={s.icon} />
              </a>
            ))}
          </div>
        </div>
        <div className="footer__divider" />
        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Soumyajit Rout</p>
        </div>
      </div>

      <AnimatePresence>
        {showTop && (
          <motion.div
            className="back-to-top"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="home" smooth duration={1200} className="back-to-top__btn">
              <i className="fa-solid fa-arrow-up" />
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  );
}

export default Footer;
